<template>
  <div class="containerFull_hengqinMara">
    <MarathonCommon
      :containerFullClassName="containerFullClassName"
      :defaultPath="defaultPath"
      :axiosBaseUrl="axiosBaseUrl"
      :sportCompetitionType="sportCompetitionType"
      :themeSeasonArr="themeSeasonArr"
    ></MarathonCommon>
  </div>
</template>

<script>
// 马拉松 珠海横琴 容器
import MarathonCommon from './marathon_common'
import containerFull_data from '@mixins/marathon/hengqinMara/containerFull_data'
export default {
  name: 'containerFull_HengqinMara',
  mixins: [containerFull_data],
  components: {
    MarathonCommon,
  },
}
</script>
